"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const RadioButton = ({ name, label, value, onClick }) => ((0, jsx_runtime_1.jsxs)("span", { className: "form-radio", children: [(0, jsx_runtime_1.jsx)("input", { type: "radio", id: value, name: name, value: value, onClick: onClick }), (0, jsx_runtime_1.jsx)("label", { htmlFor: value, children: label })] }));
exports.RadioButton = RadioButton;
